import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";

const AddOnDrivers = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const selectedAddOn = location.state?.addOn;

	// const initialPlan =
	// 	JSON.parse(localStorage.getItem("plan_code")) ||
	// 	JSON.stringify({ name: "Plan A", code: "Plan A" });

	const [selectedPlan, setSelectedPlan] = useState({
		name: "Plan A - RM 25,000",
		code: "PAB3A",
	});
	const plans = [
		{ name: "Plan A - RM 25,000", code: "PAB3A" },
		{ name: "Plan B - RM 50,000", code: "PAB3B" },
	];

	useEffect(() => {
		console.log("selected allianz PAB3", selectedPlan);
		localStorage.setItem(
			"allianz_pab3_selection",
			JSON.stringify(selectedPlan)
		);
	}, [selectedPlan]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>{t(`autoInsurance.addOnSumInsured.noAddOnSelected`)}</h3>
				<Button
					label={t(`autoInsurance.addOnSumInsured.goBack`)}
					onClick={() => navigate(-1)}
				/>
			</div>
		);
	}

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				state: {
					...selectedAddOn,
					selectedPlan, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100">
					<Dropdown
						value={selectedPlan}
						onChange={(e) => setSelectedPlan(e.value)}
						options={plans}
						optionLabel="name"
						placeholder={t(
							`autoInsurance.loapacCart.selectAnOption`
						)}
						className="w-full md:w-14rem"
					/>
				</div>

				{/* grid of 3 columns 3 rows showing addon plans details */}
				{/* headers: Benefits (per person), Plan A, Plan B */}
				{/* row: Death/Permanent Disablement, RM 25,000, RM 50,000 */}
				{/* row: Hospital Income, RM50/day, RM50/day */}
				{/* row: Funeral Expenses, RM1,000, RM2,500 */}

				<div className="add-on-details border-radius-10 w-100 mb-8rem mt-4">
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						<div className="plan-details">
							<span className="fw-bold color-heading">
								Plan A
							</span>
							<br />
							<span className="fw-bold color-heading">
								Benefits (per person):
							</span>
							<div className="text-left formatted-text">
								Death/Permanent Disablement: RM 25,000
							</div>
							<div className="text-left formatted-text">
								Hospital Income: RM50/day
							</div>
							<div className="text-left formatted-text">
								Funeral Expenses: RM1,000
							</div>
						</div>
					</div>
					<hr />
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						<div className="plan-details">
							<span className="fw-bold color-heading">
								Plan B
							</span>
							<br />
							<span className="fw-bold color-heading">
								Benefits (per person):
							</span>
							<div className="text-left formatted-text">
								Death/Permanent Disablement: RM 50,000
							</div>
							<div className="text-left formatted-text">
								Hospital Income: RM50/day
							</div>
							<div className="text-left formatted-text">
								Funeral Expenses: RM2,500
							</div>
						</div>
					</div>
					<hr />
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{t(
									`autoInsurance.addOnSumInsured.selectingAddOnsFor`
								)}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label={t(`autoInsurance.addOnsOther.returnAddOns`)}
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnDrivers;
